export default $axios => {
  return {
    /**
     * 获取验证码
     * @param {object} options
     */
    getInfo(options) {
      return $axios.post('/goForm', options)
    },

    goForm(options) {
      return $axios.post('/ocr/detect', options)
    }

  }
}